import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Route, Users, GraduationCap, LogOut } from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/', icon: LayoutDashboard, roles: ['master_admin', 'admin', 'manager', 'trainer', 'agent', 'vp_operations'] },
  { label: 'Journey', path: '/journey', icon: Route, roles: ['master_admin', 'admin', 'manager', 'trainer', 'agent', 'vp_operations'] },
  { label: 'Users', path: '/users', icon: Users, roles: ['master_admin', 'admin', 'manager', 'trainer', 'vp_operations'] },
  { label: 'Trainees', path: '/trainees', icon: GraduationCap, roles: ['master_admin', 'admin', 'manager', 'trainer', 'vp_operations'] },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const filteredItems = NAV_ITEMS.filter(item => item.roles.includes(user?.role));

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const roleName = user?.role?.replace(/_/g, ' ') || '';

  return (
    <aside data-testid="sidebar" className="fixed left-0 top-0 h-screen w-64 bg-[#F9FAFB] border-r border-[#E5E7EB] flex flex-col z-50">
      <div className="p-6 border-b border-[#E5E7EB]">
        <h1 className="font-heading text-lg font-black text-[#0A0A0A] tracking-tight leading-tight">
          Training<br />Journey Portal
        </h1>
      </div>

      <nav className="flex-1 py-4">
        {filteredItems.map(item => {
          const active = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <button
              key={item.path}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-6 py-3 text-left transition-colors duration-150
                ${active
                  ? 'border-l-4 border-[#0047FF] bg-white text-[#0A0A0A] font-semibold'
                  : 'border-l-4 border-transparent text-[#4B5563] hover:bg-white hover:text-[#0A0A0A]'
                }`}
            >
              <item.icon size={18} strokeWidth={active ? 2.5 : 2} />
              <span className="font-body text-sm">{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-[#E5E7EB]">
        <div className="px-2 mb-3">
          <p data-testid="sidebar-user-name" className="font-body text-sm font-semibold text-[#0A0A0A] truncate">{user?.name}</p>
          <p data-testid="sidebar-user-role" className="font-body text-xs text-[#4B5563] uppercase tracking-[0.15em]">{roleName}</p>
        </div>
        <button
          data-testid="logout-button"
          onClick={handleLogout}
          className="w-full flex items-center gap-2 px-2 py-2 text-sm text-[#DC2626] hover:bg-red-50 transition-colors duration-150 font-body"
        >
          <LogOut size={16} />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
